import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

const Login = lazy(() => import('./components/NavBar/Login'));
const ResetPassword = lazy(() => import('./components/NavBar/ResetPassword'));
const Homepage = lazy(() => import('./components/NavBar/Homepage'));
const AboutPage = lazy(() => import('./components/NavBar/AboutPage'));
const ContactPage = lazy(() => import('./components/NavBar/ContactPage'));
const FactoriesPage = lazy(() => import('./components/Supplier/FactoriesPage'));
const RequestsPage = lazy(() => import('./components/Buyer/RequestsPage'));
const ProductsPage = lazy(() => import('./components/Supplier/ProductsPage'));
const ProductDetail = lazy(() => import('./components/Buyer/ProductDetail'));
const ProtectedRoute = lazy(() => import('./components/ProtectedRoute'));
const ProductCreatePage = lazy(() => import('./components/Supplier/ProductCreatePage'));
const ProductEditPage = lazy(() => import('./components/Supplier/ProductEditPage'));
const RequestCreatePage = lazy(() => import('./components/Buyer/RequestCreatePage'));
const RequestEditPage = lazy(() => import('./components/Buyer/RequestEditPage'));
const RequestDetail = lazy(() => import('./components/Supplier/RequestDetail'));
const PartnersPage = lazy(() => import('./components/Buyer/PartnersPage'));
const CompanySettingsPage = lazy(() => import('./components/Master/CompanySettings'));

const PageLoader = () => (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
    </div>
);

const AppRoutes = () => {
    const { user, loading } = useAuth();

    if (loading) return <PageLoader />;

    return (
        <Suspense fallback={<PageLoader />}>
            <Routes>
                <Route
                    path="/login"
                    element={user ? <Navigate to="/home" replace /> : <Login />}
                />
                <Route
                    path="/reset-password"
                    element={<ResetPassword />}
                />
                <Route
                    path="/home"
                    element={<ProtectedRoute><Homepage /></ProtectedRoute>}
                />
                <Route
                    path="/about"
                    element={<ProtectedRoute><AboutPage /></ProtectedRoute>}
                />
                <Route
                    path="/contact"
                    element={<ProtectedRoute><ContactPage /></ProtectedRoute>}
                />
                <Route
                    path="/factories"
                    element={<ProtectedRoute><FactoriesPage /></ProtectedRoute>}
                />
                <Route
                    path="/requests"
                    element={<ProtectedRoute><RequestsPage /></ProtectedRoute>}
                />


                <Route
                    path="/requests/create"
                    element={<ProtectedRoute><RequestCreatePage /></ProtectedRoute>}
                />

                <Route
                    path="/requests/:id"
                    element={<ProtectedRoute><RequestDetail /></ProtectedRoute>}
                />


                <Route
                    path="/requests/manage/:id"
                    element={<ProtectedRoute><RequestEditPage /></ProtectedRoute>}
                />
                
                <Route
                    path="/partners" // URL'i de /partners yapabilirsin
                    element={<ProtectedRoute><PartnersPage /></ProtectedRoute>}
                />


                <Route
                    path="/products"
                    element={<ProtectedRoute><ProductsPage /></ProtectedRoute>}
                />

                <Route
                    path="/products/create"
                    element={<ProtectedRoute><ProductCreatePage /></ProtectedRoute>}
                />
                <Route
                    path="/products/edit/:id"
                    element={<ProtectedRoute><ProductEditPage /></ProtectedRoute>}
                />

                <Route
                    path="/products/:id"
                    element={<ProtectedRoute><ProductDetail /></ProtectedRoute>}
                />

                <Route
                    path="/company/settings"
                    element={<ProtectedRoute><CompanySettingsPage /></ProtectedRoute>}
                />

                <Route
                    path="/"
                    element={<Navigate to={user ? '/home' : '/login'} replace />}
                />
                <Route
                    path="*"
                    element={<Navigate to={user ? '/home' : '/login'} replace />}
                />
            </Routes>
        </Suspense>
    );
};

function App() {
    return (
        <Router>
            <AuthProvider>
                <AppRoutes />
                <Toaster position="top-right" />
            </AuthProvider>
        </Router>
    );
}

export default App;